"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ATTACHMENTS_TYPES = exports.CQ_ACTION_CHARACTERISTICS_ID = exports.CQ_OFFERING_CHARACTERISTICS_ID = exports.CHARACTERISTIC_VALUE_TYPES = exports.CHARACTERISTIC_TYPES = exports.NETFLIX_VALUES = exports.CQ_POTS = exports.TEXT_TYPES_CODES = exports.NO_ACTION_CQSI_ID = exports.CQ_ACTION_NAME = exports.CQ_ACTION_CODES = exports.PRODUCT_TYPES_TCOL = void 0;
// SHIPPING_POT Pending to delete
var PRODUCT_TYPES_TCOL = {
  FUSION: 0,
  TRIO: 1,
  BAF: 2,
  MOBILE: 3,
  DEVICE: 4,
  LINE: 5,
  TV: 6,
  NETFLIX: 7,
  SHIPPING_POT: 8,
  OTHERS: 9,
  SERVICES: 10
};
exports.PRODUCT_TYPES_TCOL = PRODUCT_TYPES_TCOL;
var CQ_ACTION_CODES = {
  NO_ACTION: '0',
  REGISTER: '1',
  UNSUBSCRIBE: '2',
  MODIFY: '3',
  MIGRATION: '11',
  UNSUBSCRIBE_DUE_TO_PORTABILITY: '12',
  KEEP: '13',
  PORTABILITY: '15',
  CONFIGURATION_CHANGE: '106'
};
exports.CQ_ACTION_CODES = CQ_ACTION_CODES;
var CQ_ACTION_NAME = {
  NO_ACTION: 'NO HACER NADA',
  REGISTER: 'ALTA',
  UNSUBSCRIBE: 'BAJA',
  MODIFY: 'MODIFICAR',
  MIGRATION: 'MIGRACION',
  UNSUBSCRIBE_DUE_TO_PORTABILITY: 'BAJA DEBIDO A PORTABILIDAD DONANTE',
  KEEP: 'MANTENER',
  PORTABILITY: 'PORTABILIDAD',
  CONFIGURATION_CHANGE: 'CAMBIO DE CONFIGURACION'
};
exports.CQ_ACTION_NAME = CQ_ACTION_NAME;
var NO_ACTION_CQSI_ID = '0';
exports.NO_ACTION_CQSI_ID = NO_ACTION_CQSI_ID;
var TEXT_TYPES_CODES = {
  ORDINARY: '1',
  ABBREVIATED: '2',
  SHORT: '3',
  EXPLANATORY: '4',
  BRIEF: '5',
  MEDIUM: '6',
  REGULAR_WITH_VALUE: '7',
  ADDITIONAL_SHORT: '8',
  SHORT_EXPLANATORY: '9'
};
exports.TEXT_TYPES_CODES = TEXT_TYPES_CODES;
var CQ_POTS = {
  PAYMENT_POT: {
    TYPE: 'POPT',
    DIRECT_DEBIT_ID: '9',
    CARD: '60',
    FUNDED: '61'
  },
  SHIPPING_POT: {
    TYPE: 'POShT',
    STORE_SHIPPING_ID: '4',
    HOME_SHIPPING_ID: '6'
  },
  INSTALLATION_POT: {
    TYPE: 'POIT',
    INSTALLATION_ID: '56'
  }
};
exports.CQ_POTS = CQ_POTS;
var NETFLIX_VALUES = {
  STANDARD: '268',
  PRIME: '269'
};
exports.NETFLIX_VALUES = NETFLIX_VALUES;
var CHARACTERISTIC_TYPES = {
  OPEN: '1',
  LIST: '2',
  RANGE: '3',
  MIXED: '4',
  COMPOUND: '5'
};
exports.CHARACTERISTIC_TYPES = CHARACTERISTIC_TYPES;
var CHARACTERISTIC_VALUE_TYPES = {
  INTEGER: '1',
  DATE: '2',
  STRING: '3',
  BOOLEAN: '4',
  QUANTITY: '5',
  MONEY: '6',
  RESOURCE_SPEC: '7',
  TEST_SPEC: '8',
  STATEMENT_TEMPLATE: '9',
  DECIMAL: '10',
  DIGIT: '11',
  PHONE_NUMBER: '12',
  HOUR: '13'
};
exports.CHARACTERISTIC_VALUE_TYPES = CHARACTERISTIC_VALUE_TYPES;
var CQ_OFFERING_CHARACTERISTICS_ID = {
  YOMVI: '15',
  NETFLIX_PLAN: '43'
};
exports.CQ_OFFERING_CHARACTERISTICS_ID = CQ_OFFERING_CHARACTERISTICS_ID;
var CQ_ACTION_CHARACTERISTICS_ID = {
  ICC: '8'
};
exports.CQ_ACTION_CHARACTERISTICS_ID = CQ_ACTION_CHARACTERISTICS_ID;
var ATTACHMENTS_TYPES = {
  ICON_EXTENDED: '1',
  ICON_SIMPLE: '2',
  RESOURCE_GRAPHIC_TEMPLATE: '3',
  IMG_LOW_RESOLUTION: '4',
  IMG_MEDIUM_RESOLUTION: '5',
  IMG_HIGH_RESOLUTION: '6',
  TYPIFICATION_LABEL: '7',
  JSON_LINKS: '8'
};
exports.ATTACHMENTS_TYPES = ATTACHMENTS_TYPES;

//# sourceMappingURL=index.js.map